import "./ServiceAreas.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import ServiceAreaIntroduction from "./sections/ServiceAreaIntroduction";
import PrimaryServiceAreasGrid from "./sections/PrimaryServiceAreasGrid";
import FeaturedCommunitiesSection from "./sections/FeaturedCommunitiesSection";
import LocalTrustSection from "./sections/LocalTrustSection";
import StormDamageSection from "./sections/StormDamageSection";
import FinalCtaSection from "./sections/FinalCtaSection";
import Footer from "@/reusable_sections/Footer";
export default function ServiceAreasPage() {
  return <div>
      <Header />
      <HeroSection />
      <ServiceAreaIntroduction />
      <PrimaryServiceAreasGrid />
      <FeaturedCommunitiesSection />
      <LocalTrustSection />
      <StormDamageSection />
      <FinalCtaSection />
      <Footer />
    </div>;
}